import React, { useEffect, useState } from "react";
import { FxButtonBase } from "../../fxms/inputs/FxButton";
import { FxLabelBase } from "../../fxms/inputs/FxLabel";
import { FxWindow } from "../../fxms/windows/FxWindows";
import { FxActionBase } from "../../fxms/actions/FxAction";
import { FxTextFieldBase } from "../../fxms/inputs/FxTextField";
import { FxFileLink } from "../../fxms/inputs/FxFileLink";
import { FxProgressBar} from "../components/FxProgressBar";
import axios from "axios";
import { toKSTISOString } from "../common/commonMethod";

/*알림조회> 등록, 상세 화면*/
export const UI_3_3_CU = (props) => {
  const {attr, onCloseBtnClick } = props;
  const [inputDatas, setInputDatas] = React.useState({
    tempAlarmFpactCnts : "",
    alarmFpactStrtDate : "",
    alarmFpactEndDate : "",
  });
  const [selectedData, setSelectedData] = React.useState({});
  const [editableYn, setEditableYn] = React.useState(
    props.name ==="ui-3-3-edit"? true : false );
  
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadedSize, setUploadedSize] = useState(0);
  const [fileUploadYn, setFileUploadYn] = useState('N');
  const [uploadedFileKey, setUploadedFileKey] = useState([]);
  const [selectedUploadedFiles, setSelectedUploadedFiles] = useState([]);
  const [isUpdate, setIsUpdate] = useState(false);

  const refershGridData = props.refershGridData? props.refershGridData: attr?attr.callback:null;


  // 날짜 형식을 YYYY-MM-DD로 변환하는 함수 추가
  const formatDateToDisplay = (dateString) => {
    if (!dateString) return '';
    return dateString.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3');
  };

  // 날짜 형식을 YYYYMMDD로 변환하는 함수 추가
  const formatDateForDB = (dateString) => {
    if (!dateString) return '';
    return dateString.replace(/-/g, '');
  };

  useEffect(() => {    
    console.log("UI_3_3_CU", props); 

    // 최초 마운트 시에만 실행되도록 수정
    if (props.selectedData) {
      if(editableYn){
        const formattedData = {
          ...props.selectedData,
          alarmFpactStrtDate: formatDateToDisplay(props.selectedData.alarmFpactStrtDate),
          alarmFpactEndDate: formatDateToDisplay(props.selectedData.alarmFpactEndDate),
          tempAlarmFpactCnts: props.selectedData.alarmFpactCnts
        };
        setSelectedUploadedFiles(props.selectedData.files);
        setSelectedData(formattedData);
        setInputDatas(formattedData);
        setUploadedFiles(props.selectedData.files);
      } else {
        const todayStr = toKSTISOString(new Date());
        setSelectedData(props.selectedData);
        setInputDatas(prev => ({
          ...prev,
          alarmFpactStrtDate: todayStr,
          alarmFpactEndDate: todayStr
        }));
      }
    }
  }, []);

  function onChangeValue(id, value) {
    let newData = { ...inputDatas };

    if (value) {
      newData[id] = value;
    } else {
      delete newData[id];
    }
    setInputDatas(newData);
  }
  

  const onRegister = async() => { 
    /*문의분류 제목 필수 체크 추가해야함 */  
      
    if(uploadedFileKey.length!==0) inputDatas.fileKeys = uploadedFileKey;

      if(selectedFiles.length !==0 && fileUploadYn==='N') {
      FxWindow.alert("파일업로드를 해주세요", true) 
      return ;      
    } 
    
    if(!validation(inputDatas)) return;
    
    const dataToSubmit = {
      ...inputDatas,
      alarmNo: selectedData.alarmNo,
      alarmFpactCnts: inputDatas.tempAlarmFpactCnts,
      alarmFpactStrtDate: formatDateForDB(inputDatas.alarmFpactStrtDate),
      alarmFpactEndDate: formatDateForDB(inputDatas.alarmFpactEndDate)
    };

    if(isUpdate) {
      let caller = new FxActionBase("vup/update_3_3/"+selectedData.alarmNo, "PUT");
      caller.execute(dataToSubmit, function (bret) {
        console.log("UI_3_3_CU regist result ", bret);
        onCloseBtnClick();                    
      });
    } else {
      // 추가
      let caller = new FxActionBase("vup/add_3_3", "POST");
      caller.execute(dataToSubmit, function (bret) {
        console.log("UI_3_3_CU regist result ", bret);
        onCloseBtnClick(); 
        if(refershGridData!==null) refershGridData();                   
      });        
    }

  }

  const onUpdate = () => { 
    setIsUpdate(true);
    setEditableYn(false);
  };

  const onCancel = () => {
    // 상태 플래그 먼저 변경
    setIsUpdate(false);
    
    const formattedData = {
      ...props.selectedData,
      alarmFpactStrtDate: formatDateToDisplay(props.selectedData.alarmFpactStrtDate),
      alarmFpactEndDate: formatDateToDisplay(props.selectedData.alarmFpactEndDate),
      tempAlarmFpactCnts: props.selectedData.alarmFpactCnts,
      alarmFpactCnts: props.selectedData.alarmFpactCnts
    };

    setSelectedData(formattedData);
    setInputDatas(formattedData);
    setEditableYn(true);

    // 파일 초기화
    setSelectedFiles([]);
    setUploadedFiles(props.selectedData.files || []);
    setUploadedSize(0);
    setFileUploadYn('N');
    setUploadedFileKey([]);
  };

  const onDelete = (item) => {
    console.log(item)

    const files = Array.from(selectedFiles).filter((f) => f !== item)

    setUploadedSize(uploadedSize-item.size);

    setSelectedFiles(files);

  }

  const onFileUpload = async (e) => {
    
    if(selectedFiles.length===0) {
      FxWindow.alert("선택한 파일이 없습니다.", true);
      return;
    }

    const formData = new FormData();

    for (let i = 0; i < selectedFiles.length; i++) {
      formData.append('files', selectedFiles[i]);
    }

    console.log(Array.from(formData));

    let dataSet = {
      url: "3_3",
      delYn: "N"  // DEL_YN 필드 추가
    };

    const json = JSON.stringify(dataSet);
    const blob = new Blob([json], { type: "application/json" });
    formData.append("data", blob);

    try {
      const response = await axios({
        method: "POST",
        url: "/api/open/upload",
        mode: "cors",
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        data: formData,
      });

      console.log('파일 업로드 : ', response.data);
      setFileUploadYn('Y');
      setUploadedFiles([...uploadedFiles, ...Array.from(selectedFiles)])
      setSelectedFiles([]);
      // response.data가 배열이 아닌 경우 배열로 변환
      const fileKeys = Array.isArray(response.data) ? response.data : [response.data];
      setUploadedFileKey(prevKeys => [...prevKeys, ...fileKeys]);
      FxWindow.alert("파일업로드가 완료되었습니다.");

      } catch (error) {
        console.error('파일 업로드 실패:', error);
        FxWindow.alert("파일 업로드에 실패했습니다.", true);
      }
    };

  const handleFileChange = (e) => {  

    if(e.target.files.length===0) {
      setUploadedSize(0);
      setSelectedFiles([]);
      return;
    }

    const selectedFiles = e.target.files;
    let fileSize = 0;  
    
    for(let file of selectedFiles){
      fileSize += file.size;
    }
  
    const limitsize = 1024 ** 2 * 10; //10MB    
  
    let fileSizeP = ((uploadedSize+fileSize) );

       if (fileSizeP > limitsize) {
      FxWindow.alert("첨부파일의 용량을 확인해주세요", true) 
      return ; 
    }
  
    setUploadedSize(fileSizeP);
   
    setSelectedFiles(selectedFiles);
       
  }

  const validation = (inputDatas) =>{


    if(inputDatas.tempAlarmFpactCnts === undefined) {
       FxWindow.alert("조치내용을 입력해주세요", true) ;
       return false;
    }

    return true;

  }

  const handleSelectData = (e) => {
    const { name, value } = e.target;
    setSelectedData({ ...selectedData, [name]: value });
  };

  const onDeleteAlarm = () => {
    console.log("onDeleteAlarm", selectedData);
    let caller = new FxActionBase("vup/delete_3_3/"+selectedData.alarmNo, "DELETE");
    caller.execute(selectedData.alarmNo, function (bret) {
      console.log("onDeleteAlarm result ", bret);
      onCloseBtnClick();
    });
  }

  return (
    <div style={{ height: '100%', overflow: 'hidden' }}>
      <div className="FxDataEdit">
        <table className="table">
        <colgroup>
            <col style={{ width: '100px' }} />
            <col style={{ width: '300px' }} />
            <col style={{ width: '100px' }} />
            <col style={{ width: '300px' }} />
          </colgroup>
          <tr>
            <th><FxLabelBase>알림발생 관리번호</FxLabelBase></th>
            <td><FxTextFieldBase name="alarmNo" onChangeValue={onChangeValue} selectedData={selectedData} disabled={true} /></td>
            <th><FxLabelBase>산업단지명</FxLabelBase></th>
            <td><FxTextFieldBase name="complexInloName" onChangeValue={onChangeValue} selectedData={selectedData} disabled={true} /></td>
          </tr>
          <tr>
            <th><FxLabelBase>회사명</FxLabelBase></th>
            <td><FxTextFieldBase name="companyInloName" onChangeValue={onChangeValue} selectedData={selectedData} disabled={true} /></td>
            <th><FxLabelBase>사업장명</FxLabelBase></th>
            <td><FxTextFieldBase name="plantInloName" onChangeValue={onChangeValue} selectedData={selectedData} disabled={true} /></td>
          </tr>
          <tr>
            <th><FxLabelBase>알람유형</FxLabelBase></th>
            <td colSpan="1"><FxTextFieldBase name="alarmClCd" onChangeValue={onChangeValue} selectedData={selectedData} disabled={true} /></td>
          </tr>
          <tr>
            <th><FxLabelBase>설비명</FxLabelBase></th>
            <td><FxTextFieldBase name="moName" onChangeValue={onChangeValue} selectedData={selectedData} disabled={true} /></td>
          </tr>
          <tr>
            <th><FxLabelBase>설비번호</FxLabelBase></th>
            <td><FxTextFieldBase name="moNo" onChangeValue={onChangeValue} selectedData={selectedData} disabled={true} /></td>
          </tr>
          <tr>
            <th><FxLabelBase>알람내용</FxLabelBase></th>
            <td colSpan="1"><FxTextFieldBase name="alarmMsg" onChangeValue={onChangeValue} selectedData={selectedData} disabled={true} /></td>
          </tr>
          <tr>
            <th><FxLabelBase>알람발생시각</FxLabelBase></th>
            <td colSpan="1"><FxTextFieldBase name="occurDtm" onChangeValue={onChangeValue} selectedData={selectedData} disabled={true} /></td>
          </tr>
          <tr>
            <th><FxLabelBase>조치내용</FxLabelBase></th>
            <td colSpan="1">
              <FxTextFieldBase 
                key={`content-${editableYn}-${isUpdate}`}
                name="tempAlarmFpactCnts"
                selectedData={editableYn ? 
                  { tempAlarmFpactCnts: selectedData.alarmFpactCnts } : 
                  { tempAlarmFpactCnts: inputDatas.tempAlarmFpactCnts }
                }
                onChangeValue={onChangeValue}
                disabled={editableYn}
              />
            </td>
          </tr>
          <tr>
            <th><FxLabelBase>조치시작일</FxLabelBase></th>
            <td>
              <input 
                className="FxDate" 
                type="date" 
                name="alarmFpactStrtDate" 
                value={inputDatas.alarmFpactStrtDate} 
                onChange={(e) => {
                  onChangeValue('alarmFpactStrtDate', e.target.value);
                  handleSelectData(e);
                }} 
                disabled={editableYn}
              />
            </td>
          </tr>
          <tr>
            <th><FxLabelBase>조치종료일</FxLabelBase></th>
            <td>
              <input 
                className="FxDate" 
                type="date" 
                name="alarmFpactEndDate" 
                value={inputDatas.alarmFpactEndDate} 
                onChange={(e) => {
                  onChangeValue('alarmFpactEndDate', e.target.value);
                  handleSelectData(e);
                }} 
                disabled={editableYn}
              />
            </td>
          </tr>
          {editableYn ?
            <> 
              <tr>
                <th><FxLabelBase>첨부</FxLabelBase></th>
                <td>
                  {selectedUploadedFiles?.map((item)=> (
                      <span key={item.fileId}> <FxFileLink fileId={item.fileId} fileUrl={'3_3'} orgNm={item.name}></FxFileLink> </span>
                ))}
                </td>
              </tr> 
            </> : 
            <tr>
              <th rowSpan='2'><FxLabelBase>첨부</FxLabelBase></th>
              <td colSpan="3">
                <div className="VupFileUpWrap">
                  <input
                    id="fileUp"
                    className='file-input'
                    type="file"                 
                    onChange={handleFileChange}
                    multiple="multiple"
                    disabled={editableYn}
                  />
                  <div className="fileInput"> </div>
                  <button >파일선택</button>  

                </div>
                <FxProgressBar percent={uploadedSize/ (1024 ** 2  * 10) * 100} baseNum={1024 ** 2 * 10}/> 
                <ul className="VupFileUpList">
                  {Array.from(uploadedFiles).map((item) => (
                    <li className="fin">
                      <span>{item.name}</span>
                    </li>
                  ))}
                  {Array.from(selectedFiles).map((item) => (
                    <li>
                      {item.name}
                      <button onClick={() => onDelete(item)}> </button>
                    </li>
                  ))}
                </ul>
                <ul className="VupFileUpNotice">
                    <li>첨부한 파일의 전체 크기는 10Mbyte 미만이어야 합니다.</li>
                    <li>용량이 초과될 경우, 문의 접수가 원활하게 진행되지 않을 수 있습니다.</li>
                    <li>파일첨부는 JPG, GIF, PSD, TIF, MS Office 파일, 아래한글, PDF만 가능합니다.</li>
                </ul>
              </td>
            </tr>}
        </table>
      </div>
      <div className="FxCrudToolbar">
        <div className="FxFilterLeft">
        </div>
        <div className="FxFilterRight">
          {editableYn ? (
            // 조회 모드
            <>
              <FxButtonBase name="click" onClick={onUpdate} text="수정" />
              <FxButtonBase name="click" onClick={onDeleteAlarm} text="삭제" />
            </>
          ) : (
            // 등록/수정 모드
            <>
              <FxButtonBase name="click" onClick={onFileUpload} text="파일업로드" />
              <FxButtonBase name="click" onClick={onRegister} text="등록" />
              {isUpdate && <FxButtonBase name="click" onClick={onCancel} text="취소" />}
            </>
          )}
        </div>
        
      </div>
    </div>
  )
}
